import { Card, type CardProps } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import { FlatCard } from "../Cards/FlatCard";
import { Skeleton } from "../Skeleton";
import { getRecommendedCardLayout } from "./helpers";

const RING_SIZE = 48;

type Props = {
	cardWidth?: number;
	style?: CardProps["style"];
};

export const RecommendedCardSkeleton = ({ cardWidth, style }: Props) => {
	const theme = useAppTheme();
	const { isMobile, isSmallScreen } = useDevice();
	const { stackFooter } = getRecommendedCardLayout({
		cardWidth,
		isMobile,
		isSmallScreen,
	});

	return (
		<FlatCard
			style={[{ width: cardWidth, flex: 1 }, style]}
			contentStyle={{ flexGrow: 1 }}
		>
			<Card.Content
				style={{
					flexGrow: 1,
					padding: 16,
					gap: 16,
					justifyContent: "space-between",
				}}
			>
				<Box flexDirection="row" alignItems="flex-start" gap={8}>
					<Skeleton size={RING_SIZE} variant="circle" />
					<Box flex={1} gap={4}>
						<Skeleton width="70%" height={24} />
						{isMobile ? null : <Skeleton width="90%" height={16} />}
					</Box>
				</Box>
				<Box
					width="100%"
					flexDirection={stackFooter ? "column" : "row"}
					alignItems={stackFooter ? "flex-start" : "center"}
					justifyContent="space-between"
					gap={stackFooter ? 8 : 16}
				>
					<Box flexDirection="row" gap={4} flexShrink={1} minWidth={0}>
						<Skeleton width={80} height={28} borderRadius={theme.roundness} />
						<Skeleton width={80} height={28} borderRadius={theme.roundness} />
					</Box>
					<Box flexShrink={0}>
						<Skeleton
							width={94}
							height={40}
							borderRadius={theme.roundness * 5}
						/>
					</Box>
				</Box>
			</Card.Content>
		</FlatCard>
	);
};
